<template>
<v-card class="mb-3">
    <v-card-title>Comercios</v-card-title>
    <v-card-text v-if="!minimal">
        <Search :default="params" @search="search($event)" :loading="loading"/>
    </v-card-text>
    <v-card-text>
        <component :is="reporte" :params="params" :loading.sync="loading"/>
    </v-card-text>
</v-card>
</template>
<script>
import Comercio from '@components/entities/reporte/venta/comercio';
import Search from '@components/entities/reporte/venta/comercio/search';
import TicketList from '@components/entities/ticket';

export default {
    components: {
        Comercio,
        Search,
        TicketList
    },
    props: {},
    data: function() {
        const query = {... this.$route.query};

        for (const key in query) {
            if (Object.hasOwnProperty.call(query, key)) {
                const element = query[key];
                console.log(key, query[key], this.$lodash.isNumber(element));
                query[key] = /^-?[\d.]+(?:e-?\d+)?$/.test(element) ? Number.parseFloat(element): element;
            }
        }

        return {
            params: {
                daterange: [this.$luxon.now().toISODate(),this.$luxon.now().toISODate()],
                ... query,
            },
            loading: false,
            minimal: query['minimal'],
        }
    },
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', '');
    },
    computed:{
        reporte: function() {
            if (this.params?.taquilla_id) return 'TicketList';
            return 'Comercio';    
        },
    },
    methods:{
        search: function (params) {
            this.params = params;
        }
    },
}
</script>